import { z } from 'zod';
/** Re-authentication payload attached to sensitive requests (send, export key, security changes). */
export const zStepUp = z.object({
    password: z.string().min(1).max(128).optional(),
    totpCode: z
        .string()
        .trim()
        .regex(/^\d{6}$/, 'Enter the 6-digit code from your authenticator app')
        .optional(),
});
//# sourceMappingURL=auth.js.map